import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {EventText} from '../../../../../../commons/components/event-text'
import {useCommonDateInformation} from '../../../../../../commons/hooks/dates'
import {useMembersPageCurrencyFormatter} from '../../../hooks/currency'
import {ExpandableRow} from '../../expandable-row'
import {OrderRowProps} from './interfaces'
import s from './order-row.scss'

export const OrderRow = ({order, lastRow, onClick}: OrderRowProps) => {
  const {t} = useTranslation()
  const {orderNumber} = order
  const orderDate = useCommonDateInformation(orderNumber)
  const {getFormattedMoney} = useMembersPageCurrencyFormatter()

  return (
    <ExpandableRow
      mobile
      navigable
      key={order.orderNumber}
      divider={!lastRow}
      toggle={onClick}
      arrowClass={s.arrow}
      t={t}
    >
      <div>
        <div data-hook={DH.MOBILE_ORDER_NUMBER}>
          <EventText>{t('mobile.order.number', {orderNumber})}</EventText>
        </div>
        <div className={s.date} data-hook={DH.MOBILE_ORDER_DATE}>
          <EventText faded>{t('mobile.order.date', {date: orderDate})}</EventText>
        </div>
        <div className={s.total} data-hook={DH.MOBILE_ORDER_TOTAL}>
          <EventText>{t('mobile.order.total', {total: getFormattedMoney(order.invoice.grandTotal)})}</EventText>
        </div>
      </div>
    </ExpandableRow>
  )
}
